module.exports = __webpack_public_path__ + "img/Layer 18.db33c80a.svg";